// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3uSxx","search":"Settings_search__yL97s","filter":"Settings_filter__1gI4S"};